const SelectionActionBarTestIdsScope = {
  SELECTION_ACTION_BAR: 'selection-action-bar',
};

export const SelectionActionBarTestIds = {
  MERGE_BUTTON: `${SelectionActionBarTestIdsScope.SELECTION_ACTION_BAR}.merge-button`,
  COPY_BUTTON: `${SelectionActionBarTestIdsScope.SELECTION_ACTION_BAR}.copy-button`,
  CLEAR_BUTTON: `${SelectionActionBarTestIdsScope.SELECTION_ACTION_BAR}.clear-button`,
};
